module.exports = __webpack_public_path__ + "images/category_lp/bike/new/store_images/5_0f97c6d4c760d08dd00c865dd838c2d1.png";